<!-- Gastroscopy 胃鏡 -->
<!-- examinationTypeID === 1 -->

<template>
  <v-tabs v-model="findingsTabActive">
    <confirm-dialog
      :showDialog="showDialog"
      :message="confirmMessage"
      :title="confirmTitle"
      :onConfirm="onConfirmHandler.bind(this)"
      :onCancel="cancelDialog.bind(this)"
    >
    </confirm-dialog>
    <v-tab
      ripple
      href="#tab-all"
    >
      All Images
    </v-tab>

    <v-tab
      ripple
      href="#tab-nega"
      v-show="getFindings.length == 0"
    >
      Negative finding
    </v-tab>
    
    <v-tab
      :class="findingsTabActive - 1 == n? 'findingTabActive' : 'findingTabDeactivate'"
      v-for="n in findingsLength"
      :key="n"
      ripple
      @click="openTabIndex(0)"
    >
      <div >
          <div><h1>{{ n }}</h1></div>
          <div><h4>{{ getFindingName( n ) }} </h4></div>
      </div>
    </v-tab>
    <v-btn icon flat color="grey" @click="addFinding">
      <v-icon>add</v-icon>
    </v-btn>
  
    <!-- All tab -->
    <v-tab-item value="tab-all">
      <report-filtering-images
        class="elevation-0 mt-2"
        :findings="getFindings"
        :allImages="getAllImages"
        :landmarksList="getLandmarkList"
        hideFilterChips
        hideFocusItem
        @imgStatusChange="toggleImgStatus('all', $event)"
        @findingChange="moveImgFromAllToFinding"
        @landmarkChange="imgLandmarkChange"
        @deleteImg="showConfirmPopup(null, $event, null)"
      ></report-filtering-images>
    </v-tab-item>

<!-- Negative finding tab -->
      <v-tab-item value="tab-nega" v-show="getFindings.length == 0">
        <v-card flat class="mt-2 pt-2 findings-container">
          <v-card-text>
            <v-layout row wrap>

              <v-flex xs12 class="mb-2">
                <div class="findings-tab-title title font-weight-light">
                  {{negativeFinding}}
                </div>
              </v-flex>

                <div class="finding-bottom">
                  <v-textarea
                    label="Negative Suggestion"
                    :value = "getNegaSuggestion"
                    @change="saveNegaSuggestion({ event: { field: 'negaSuggestion', newValue: $event } })"
                    no-resize
                    outline
                    height="120px"
                  ></v-textarea>
                  <v-btn style="background-color:#EA7500; color: #ffffff;" @click="goToPreview()">預覽列印</v-btn>
                </div>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-tab-item>

    <!-- Findings tab -->
    <template v-if="getFindings && getFindings.length > 0">
      <v-tab-item
        v-for="(finding, findingIndex) in getFindings"
        :key="finding.id"
      >
        <v-card flat class="mt-2 pt-2 findings-container">
          <v-card-text>
            <v-layout row wrap>

              <v-flex xs12 class="mb-2">
                <div class="findings-tab-title title font-weight-light">
                  Finding {{ findingIndex + 1 }}
                </div>
              </v-flex>

              <v-flex
                xs6
                class="pr-2 py-4"
                v-if="finding && getQuestionsList"
              >
                <v-layout row wrap>
                  <v-flex xs12>
                    <examination-findings-form-level-one
                      :finding="finding"
                      :findingIndex="findingIndex"
                      :questions="getQuestionsList"
                      @change="saveQuestionInput({ findingIndex: findingIndex, event: $event })"
                      class="pa-0 mb-4"
                    ></examination-findings-form-level-one>

                    <div class="wavemed-horizontal-stepper-container">
                      <template v-for="(record, recordIndex) in finding.records">
                        <div class="wavemed-horizontal-stepper-item findings-form-level-two-container" :key="recordIndex">
                          <div :class="[recordIndex == openedRecordIndex ? 'active' : '', 'wavemed-horizontal-stepper-header']"
                            @click="openTabIndex(recordIndex)">
                            <v-chip color="primary" text-color="white">{{ recordIndex + 1 }}</v-chip>
                            <div class="v-stepper__label" v-if="finding.records.length > 0 && finding.questions.takeNote && Number(finding.questions.takeNote.value) == 499">
                              The most significant
                            </div>
                            <div class="v-stepper__label" v-else-if="finding.records.length > 0 && finding.questions.takeNote && Number(finding.questions.takeNote.value) == 501">
                              Overall
                            </div>
                            <div class="v-stepper__label" v-else><!-- 無 number -->
                              Lesion <span v-if="finding.records.length > 1">{{ recordIndex + 1 }}</span>
                            </div>
                          </div>
                          <examination-findings-form-level-two
                            :show="recordIndex == openedRecordIndex"
                            :findingIndex="findingIndex"
                            :recordIndex="recordIndex"
                            :record="record"
                            :questions="getQuestionsList"
                            :hiddenParams="getStoreHiddenParameter"
                            :examination_typeID="getExaminationData.examination.examination_typeID"
                            @change="saveQuestionInput({ findingIndex: findingIndex, recordIndex: recordIndex, event: $event })"
                            @addLocation="addExaminationLocation({ recordID: record.id, findingIndex })"
                            @deleteLocation="deleteExaminationLocation({ locationID: $event, recordIndex, findingIndex })"
                            @locationChange="updateExaminationLocationColumn({ findingIndex, recordIndex, $event })"
                            class="pt-2"
                          >
                            <template slot="form-bottom">
                              <!--
                              <v-textarea
                                label="Diagnosis"
                                v-model="record.diagnosis"
                                @change="saveQuestionInput({ findingIndex: findingIndex, recordIndex: recordIndex, event: { field: 'diagnosis', newValue: $event } })"
                                no-resize
                                outline
                                hide-details
                                height="88px"
                                row-height="20px"
                                class="mt-0 pt-0"
                              ></v-textarea>
                              <v-textarea
                                label="Summary"
                                v-model="record.summary"
                                @change="saveQuestionInput({ findingIndex: findingIndex, recordIndex: recordIndex, event: { field: 'summary', newValue: $event } })"
                                no-resize
                                outline
                                hide-details
                                height="88px"
                                row-height="20px"
                                class="mt-0 pt-2"
                              ></v-textarea>
                              -->
                              <!--
                              <div class="article" v-show="!getEditArticleStatus[findingIndex][recordIndex]"><b>Diagnosis</b><br><span v-bind:id="'diagnosis_' + findingIndex + '_' + recordIndex" v-html="record.diagnosis"></span></div>
                              <div class="article" v-show="getEditArticleStatus[findingIndex][recordIndex]"><b>Diagnosis</b><br><span v-bind:id="'editDiagnosis_' + findingIndex + '_' + recordIndex"></span></div>
                              <div class="article" v-show="!getEditArticleStatus[findingIndex][recordIndex]"><b>Summary</b><br><span v-bind:id="'summary_' + findingIndex + '_' + recordIndex" v-html="record.summary"></span></div>
                              <div class="article" v-show="getEditArticleStatus[findingIndex][recordIndex]"><b>Summary</b><br><span v-bind:id="'editSummary_' + findingIndex + '_' + recordIndex"></span></div>
                              <v-btn color="info" v-show="!getEditArticleStatus[findingIndex][recordIndex]" @click="getSummaryAndDiagnosis(findingIndex, recordIndex, record.id)"> 自動產生文章 </v-btn>
                              <v-btn v-show="!getEditArticleStatus[findingIndex][recordIndex]" color="info" @click="editArticle(findingIndex, recordIndex)"> 編輯文章 </v-btn>
                              <v-btn v-show="getEditArticleStatus[findingIndex][recordIndex]" color="info" @click="saveArticle(findingIndex, recordIndex)"> 儲存文章 </v-btn>
                              -->
                            </template>
                          </examination-findings-form-level-two>
                        </div>
                      </template>
                      <template v-for="(record, recordIndex) in finding.records">
                        <template>
                          <div v-show="recordIndex == openedRecordIndex">
                            <v-btn color="info" v-show="!getEditArticleStatus[findingIndex][recordIndex]" @click="getSummaryAndDiagnosis(findingIndex, recordIndex, record.id)"> 自動產生文章 </v-btn>
                            <!-- <v-btn v-show="!getEditArticleStatus[findingIndex][recordIndex]" color="info" @click="editArticle(findingIndex, recordIndex)"> 編輯文章 </v-btn> -->
                            <!-- <v-btn v-show="getEditArticleStatus[findingIndex][recordIndex]" color="info" @click="saveArticle(findingIndex, recordIndex)"> 儲存文章 </v-btn> -->
                            <!-- <a style="color: #FF95CA; font-weight: bold;" v-if="finding.records.length > 0 && finding.questions.takeNote && Number(finding.questions.takeNote.value) == 499">
                              # The most significant
                            </a>
                            <a style="color: #FF95CA; font-weight: bold;" v-else-if="finding.records.length > 0 && finding.questions.takeNote && Number(finding.questions.takeNote.value) == 501">
                              # Overall
                            </a>
                            <a style="color: #FF95CA; font-weight: bold;" v-else>
                              # Lesion <span v-if="finding.records.length > 1">{{ recordIndex + 1 }}</span>
                            </a> -->
                          </div>
                        </template>
                      </template>

                      <section class="pa-2" v-if="getOrderArticle && findingContent(finding.id)">
                        <!-- article -->
                        <FindingItemContent
                          :hasActionTrigger="false"
                          :finding="findingContent(finding.id)"
                        />
                      </section>
                      <p v-if="!getOrderArticle" class="pl-2">Nil</p>
                    </div>
                  </v-flex>
                </v-layout>
                <div class="finding-bottom">
                  <v-textarea
                      label="Suggestion"
                      v-model="finding.suggestion"
                      @change="saveQuestionInput({ findingIndex: findingIndex, event: { field: 'suggestion', newValue: $event } })"
                      no-resize
                      outline
                      height="120px"
                    ></v-textarea>
                  <v-btn style="background-color: rgb(33, 150, 243); color: #ffffff;" @click="previousFinding(findingIndex)">
                    Previous
                  </v-btn>
                  <v-btn style="background-color: rgb(33, 150, 243); color: #ffffff;" @click="nextFinding(findingIndex)">
                    Next
                  </v-btn>
                  <v-btn
                    flat outline color="red"
                   @click="showConfirmPopup (findingIndex)"
                  ><v-icon>delete</v-icon>Delete
                  </v-btn>
                  <v-btn style="background-color:#EA7500; color: #ffffff;" @click="goToPreview()">
                    預覽列印
                  </v-btn>
                </div>
              </v-flex>

              <v-flex xs6 class="pl-2">
                <v-container fluid grid-list-lg class="pl-0">
                  <v-layout
                    v-if="finding.images && finding.images.length > 0"
                    row wrap
                    class="findings-imgs filter-group-container"
                  >
                    <v-flex v-for="(imgItem, imgIndex) in finding.images" :key="imgItem.id" xs4 class="mb-4">
                      <screenshot-image-item
                        :findingIndex="findingIndex + 1"
                        :class="{ 'selected-print': imgItem.status === '1' } "
                        :item="imgItem"
                        :number ="imgIndex + 1"
                        :findingSelectItems="findingSelectItems"
                        :landmarkSelectItems="landmarkSelectItems"
                        :landmarkText="imgItem.landmarkID === 0 ? null : getLandmarkTextByID(imgItem.landmarkID)"
                        @imgStatusChange="toggleImgStatus(findingIndex, imgIndex)"
                        @findingChange="showConfirmPopup(null, imgItem.id, $event)"
                        @landmarkChange="imgLandmarkChange({id: imgItem.id, newValue: $event})"
                        @deleteImg="showConfirmPopup(null, $event, null)"
                      ></screenshot-image-item>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>

            </v-layout>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </template>
  </v-tabs>
</template>

<script>
const API_URL = process.env.VUE_APP_API_URL

/* methods */
import {
    mapGetters,
    mapActions
} from 'vuex'
import forms from '@/utils/forms'

/* components */
import {
    VTextField,
    VCheckbox,
    VSelect
} from 'vuetify/lib'
import ReportFindingsFormLevelOne from '@/components/ReportFindingsFormLevelOne.vue'
import AttachToPrintBtn from '@/components/imgOverlay/attachToPrintBtn.vue'
// import RemoveFromFindingBtn from '@/components/imgOverlay/removeFromFindingBtn.vue'
import ImgOverlay from '@/components/imgOverlay/imgOverlay.vue'

import ReportFilteringImages from '@/components/ReportFilteringImages.vue'
import ExaminationFindingsFormLevelOne from '@/components/examinations/ExaminationFindingsFormLevelOne.vue'
import ExaminationFindingsFormLevelTwo from '@/components/examinations/ExaminationFindingsFormLevelTwo.vue'
import ScreenshotImageItem from '@/components/screenshots/ScreenshotImageItem.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import FindingItemContent from '@/components/commons/FindingItemContent.vue'

export default {
    name: 'ReportFindingDetails',

    props: {
        reporType: Number
    },
    components: {
        ReportFindingsFormLevelOne,
        VTextField,
        VCheckbox,
        VSelect,
        AttachToPrintBtn,
        // RemoveFromFindingBtn,
        ImgOverlay,
        ReportFilteringImages,
        ExaminationFindingsFormLevelOne,
        ExaminationFindingsFormLevelTwo,
        ScreenshotImageItem,
        ConfirmDialog,
        FindingItemContent
    },

    data() {
        return {
            examinationTypeID: this.reporType,
            findingsTabActive: 1,

            // showOverlay is an object, to control each image's overlay state
            showOverlay: null,
            coreFormItems: [],
            questionsJSON: null,

            imgDownloadLink: null,

            confirmMessage: '',
            confirmTitle: '',
            onConfirmHandler: () => {},
            showDialog: false,
            openedRecordIndex: 0,
            eventListenerArray: []
        }
    },

    created() {
        this.initShowOverlayObj()
        this.fetchOrderArticle({ examinationID: this.getExaminationData.examination.id })
    },

    updated() {
        const _this = this;
        var temp = document.querySelectorAll("i[data-focus]");
        for (var i = 0; i < temp.length; i++) {
            if (_this.eventListenerArray.indexOf(temp[i]) == -1) {
                _this.eventListenerArray.push(temp[i]);
                temp[i].addEventListener("click", function() {
                    var part = (this.getAttribute('id').split('_').length == 3) ? 'i' : 'd';

                    if (this.getAttribute('data-focus') == 'interven') {
                        part = 'i';
                    }
                    _this.openTabIndex(this.parentNode.getAttribute('id').split('_')[2]);
                    _this.setStoreHiddenParameter({
                        target: 'focus',
                        value: this.getAttribute('data-focus'),
                        part: part
                    });
                });
            }
        }
    },

    computed: {
        ...mapGetters('examinations', [
            'getExaminationData',
            'getLandmarkList',
            'getFindingsRecordsQuestions',
            'getQuestionsList',
            'getStoreHiddenParameter',
            'getEditArticleStatus',
            'getOrderArticle'
        ]),
        findingContent () {
          return (id) => {
            return this.getOrderArticle ? this.getOrderArticle.find(i => i.id === id) : {}
          }
        },

        getFindings() {
            return this.getExaminationData ? this.getExaminationData.findings : null
        },

        negativeFinding() {
            var findingName = "Negative finding"
            var insertionLevel = "1,4"

            if (this.getExaminationData) {
                if (this.getExaminationData.examination.examination_typeID != 1 && insertionLevel.indexOf(this.getExaminationData.examination.insertionLevel) != -1) {
                    findingName = "Negative finding in the observable segments"
                }
            }

            return findingName
        },

        getNegaSuggestion() {
            return this.getExaminationData ? this.getExaminationData.examination.negaSuggestion : null
        },

        findingsLength() {
            return this.getFindings ? this.getFindings.length : 0
        },

        findingsRecordsLength() {
            return this.getFindings.map(finding => finding.records.length)
        },

        getAllImages() {
            return this.getExaminationData.all
        },

        getAllImagesLength() {
            return this.getAllImages.length
        },

        landmarkSelectItems() {
            let items = this.getLandmarkList.map(elm => {
                return {
                    value: elm.id,
                    text: elm.landmark
                }
            })

            items.unshift({
                value: 0,
                text: "Choose"
            })

            return items
        },

        findingSelectItems() {
            let items = this.getFindings.map((elm, index) => {
                return {
                    value: elm.id,
                    text: `Finding ${index + 1}`
                }
            })

            items.unshift({
                value: 0,
                text: "Choose"
            })

            return items
        }
    },

    methods: {
        ...mapActions('screenshots', [
            'setScreenshotGroup', 'setScreenshotStatus', 'deleteScreenshot'
        ]),

        ...mapActions('examinations', [
            'addExaminationLocation',
            'deleteExaminationLocation',
            'updateExaminationLocationColumn',
            'setStoreHiddenParameter',
            'fetchOrderArticle'
        ]),

        getFindingName(n) {
          let arr = []
          let findingName = []
          if (this.getQuestionsList == null) {
            return
          } else if (this.getQuestionsList[19]) {
            for (let i in this.getFindings) {
              arr.push(this.getFindings[i].questions.finding.value)
            }
            // find the gastro          
            findingName = this.getQuestionsList[19].options[arr[n-1]]
          } else if (this.getQuestionsList[20]) {
            for (let i in this.getFindings) {
              arr.push(this.getFindings[i].questions.finding.value)
            }
            // find the colon & sig
            findingName = this.getQuestionsList[20].options[arr[n-1]]
          }
          return findingName
        },

        goToPreview() {
            this.$router.push({
                path: `/reports/${this.getExaminationData.examination.id}/accNo/0/preview`
            })
        },

        previousFinding(n) {
            if (n == 0) {
                this.findingsTabActive = 2;
            } else {
                this.findingsTabActive = n + 1;
                this.setStoreHiddenParameter({
                    target: 'focus',
                    value: 'finding',
                    part: 'd'
                });
                this.openTabIndex(0);
            }
        },

        nextFinding(n) {
            if (n == (this.getFindings.length - 1)) {
                // console.log('end');
            } else {
                // console.log('next');
                this.findingsTabActive = n + 3;
                this.setStoreHiddenParameter({
                    target: 'focus',
                    value: 'finding',
                    part: 'd'
                });
                this.openTabIndex(0);
            }
        },

        initShowOverlayObj() {
            let obj = {}

            if (this.findingsLength > 0) {
                this.findingsTabActive = 2
            } else {
                this.findingsTabActive = "tab-nega"
            }

            for (let i = 0; i < this.findingsLength; i++) {
                if (!this.getFindings[i].images) {
                    continue
                }
                const imgLen = this.getFindings[i].images.length
                const arrWithFalseValues = this.createArrayWithSameValue(imgLen, false)

                obj[`findings${i}`] = arrWithFalseValues
            }

            obj.all = this.createArrayWithSameValue(this.getAllImagesLength, false)

            this.showOverlay = obj

        },

        prefixServerImgPath(path) {
            return `${API_URL}/public/upload/image/${path}`
        },

        toggleImgOverlay(n, i) {
            if (n === 'all') {
                const currValue = Number(this.showOverlay.all[i])
                this.showOverlay.all.splice(i, 1, !currValue)
            } else {
                const currValue = this.showOverlay[`findings${n}`][i]
                this.showOverlay[`findings${n}`].splice(i, 1, !currValue)
            }
        },

        moveImgFromAllToFinding({
            id,
            newValue
        }) {
            const updateObj = {
                imgID: id,
                newValue
            }

            this.$store.dispatch('examinations/moveImgFromAllToFinding', updateObj)
        },

        removeImgFromFinding(findingIndex, imgIndex) {
            const item = this.getFindings[findingIndex].images[imgIndex]
            const obj = {
                imgID: item.id,
                item,
                findingIndex,
                imgIndex
            }

            this.$store.dispatch('examinations/removeImgFromFinding', obj)
        },

        /**********************************************
        /* be aware of string and number "1"          *
        **********************************************/
        toggleImgStatus(n, i) {
            const item = n === 'all' ? this.getAllImages[i] : this.getFindings[n].images[i]
            const currStatus = item.status
            const newStatus = currStatus === "0" ? "1" : "0"
            const imgID = item.id
            const findingID = item.findingID
            const landmarkID = item.landmarkID
            const obj = {
                imgID,
                newStatus,
                item,
                findingID,
                landmarkID
            }

            if (item.findingID !== 0) {
                this.$store.dispatch('examinations/updateScreenshotStatusInFinding', obj)
            }

            this.$store.dispatch('examinations/updateScreenshotStatusInAll', {
                ...obj,
                imgIndex: i
            })
        },

        imgSelectedToPrint(n, i) {
            if (n === 'all') {
                return this.getAllImages[i].status === '0' ? true : false
            }

            return this.getFindings[n].images[i].status === '0' ? true : false
        },

        questionComponentProps(n, i, item) {
            if (item.inputType === 'c') {
                return
            }

            const type = item.inputType
            const propsObj = {
                label: item.question,
                value: this.getFindings[n].records[i].questions[item.field].value
            }

            if (type === 's') {
                return Object.assign(propsObj, forms.prepareSelectQuestionProps(item))
            } else if (type === 't') {
                return propsObj
            }

            return null
        },

        prepareCheckboxQuestionProps(n, i, option) {
            const label = option.value
            const value = Number(option.key)

            return {
                label,
                value,
                'input-value': this.getFindings[n].records[i].questions[option.field].value
            }
        },

        typeOfQuestion: (type) => forms.formTypeDirective(type),
        createArrayWithSameValue: (size, item) => Array(size).fill(item),
        prepareSelectItems: (options) => forms.prepareSelectItems(options),

        /*
        updateFindingFormBinding (findingIndex, obj) {
          const updateObj = {
            examinationID: this.getFindings[findingIndex].examinationID,
            findingID: this.getFindings[findingIndex].id,
            findingIndex,
            questionID: obj.questionID,
            item: obj.item,
            field: obj.field,
            newValue: obj.newValue
          }

          this.$store.dispatch('examinations/updateFindingQuestions', updateObj)
        },*/

        /*
        updateFindingRecordsFormBinding (obj) {
          const n = obj.n
          const i = obj.i
          const updateObj = {
            examinationID: this.getFindings[n].examinationID,
            findingID: this.getFindings[n].id,
            findingIndex: n,
            questionID: obj.item.questionID,
            item: this.getFindings[n].records[i].questions[obj.item.field],
            field: obj.item.field,
            newValue: obj.newValue,
            recordID: this.getFindings[n].records[i].id,
            recordIndex: i
          }

          this.$store.dispatch('examinations/updateFindingRecordsQuestions', updateObj)
        },
        */

        saveQuestionInput(obj) {
            const findingIndex = obj.findingIndex
            const recordIndex = obj.recordIndex
            const field = obj.event.field
            const value = obj.event.newValue
            const item = obj.event.item
            
            let d = {
                examination_typeID: this.examinationTypeID,
                findingIndex,
                recordIndex,
                findingID: this.getFindings[findingIndex].id,
                field,
                value,
                item
            }

            if (typeof(d.value) == 'string') {
              d.value =  d.value.replace(/\'/gi,"\\'");
            }

            if (recordIndex !== undefined) {
                d.recordID = this.getFindings[findingIndex].records[recordIndex].id
            }

            if (field == "takeNote") {
                if (value == "499" || value == "501") {
                    this.openedRecordIndex = 0;
                }
            }
            if (field == 'number') {
                if (!isNaN(value) || value == 'several' || value == 'multiple') {
                    this.$store.dispatch('examinations/updateFindingQuestions', d)
                } else {
                    d.value = 1;
                    this.$store.dispatch('examinations/updateFindingQuestions', d)
                }
            } else {
                if (obj.event.inputType) {
                    let inputType = obj.event.inputType
                    let temp_value = null;
                    if (inputType == 's') {
                        if (d.recordID) {
                            temp_value = this.getFindings[findingIndex].records[recordIndex].questions[field].value;
                        } else {
                            temp_value = this.getFindings[findingIndex].questions[field].value;
                        }
                        if (d.value == temp_value) {
                            d.value = '';
                        }
                    } else if (inputType == 'n') {
                        if (d.value == 0) {
                            d.value = '';
                        }
                    }
                }
                let maneuver = ['coldSnare', 'hotSnare', 'snare']
                if(d.field && maneuver.indexOf(d.field) > -1 && this.getFindings[findingIndex] && this.getFindings[findingIndex].records && this.getFindings[findingIndex].records[recordIndex]){
                  let record =  this.getFindings[findingIndex].records[recordIndex]
                  for(let i = 0; i < maneuver.length; i++){
                    if(record.questions[maneuver[i]] && record.questions[maneuver[i]].value && record.questions[maneuver[i]].value[0]) {
                      let o = {
                        examination_typeID: this.examinationTypeID,
                        findingIndex,
                        recordIndex,
                        findingID: this.getFindings[findingIndex].id,
                        field: record.questions[maneuver[i]].config.field,
                        recordID: this.getFindings[findingIndex].records[recordIndex].id,
                        value: [ null ],
                        item
                      }
                      this.$store.dispatch('examinations/updateFindingQuestions', o)
                    }
                  }
                }
                this.$store.dispatch('examinations/updateFindingQuestions', d)
            }
        },

        saveNegaSuggestion(obj) {
            const field = obj.event.field
            const value = obj.event.newValue

            let d = {
                examinationID: this.getExaminationData.examination.id,
                field,
                value
            }
            this.$store.dispatch('examinations/updateColumnById', d)
        },

        addFinding() {
            const examinationID = this.getExaminationData.examination.id
            this.$store.dispatch('examinations/addFinding', examinationID).then(() => {
                if (this.findingsTabActive == "tab-nega") {
                    this.findingsTabActive = 2;
                    this.setStoreHiddenParameter({
                        target: 'focus',
                        value: 'finding',
                        part: 'd'
                    });
                    this.openTabIndex(0);
                } else {
                    this.findingsTabActive = this.getFindings.length + 1;
                    this.setStoreHiddenParameter({
                        target: 'focus',
                        value: 'finding',
                        part: 'd'
                    });
                    this.openTabIndex(0);
                }
            });
        },

        deleteFinding(n) {
            const findingID = this.getFindings[n].id
            this.$store.dispatch('examinations/deleteFinding', {
                findingID,
                findingIndex: n
            }).then(() => {
                if (this.getFindings.length > 0) {
                    if (n == 0) {
                        if (this.getFindings.length == 1) {
                            this.findingsTabActive = 0;
                            this.setStoreHiddenParameter({
                                target: 'focus',
                                value: 'finding',
                                part: 'd'
                            });
                            this.openTabIndex(0);
                        } else {
                            this.findingsTabActive = 2;
                            this.setStoreHiddenParameter({
                                target: 'focus',
                                value: 'finding',
                                part: 'd'
                            });
                            this.openTabIndex(0);
                        }
                    } else {
                        if (this.getFindings.length > (n + 1)) {
                            this.findingsTabActive = (Number(n) + 2);
                            this.setStoreHiddenParameter({
                                target: 'focus',
                                value: 'finding',
                                part: 'd'
                            });
                            this.openTabIndex(0);
                        } else {
                            this.findingsTabActive = (Number(n) + 1);
                            this.setStoreHiddenParameter({
                                target: 'focus',
                                value: 'finding',
                                part: 'd'
                            });
                            this.openTabIndex(0);
                        }
                    }
                }
            });
            this.cancelDialog()
        },
        cancelDialog() {
            this.showDialog = false
        },

        imgLandmarkChange({
            id,
            newValue
        }) {
            const updateObj = {
                imgID: id,
                newValue: newValue,
                page: 'r'
            }

            this.$store.dispatch('examinations/imgLandmarkChange', updateObj)
        },

        getLandmarkTextByID(id) {
          const item = this.getLandmarkList.find(elm => elm.id === Number(id))
          if (item) {
            return item.landmark
          } else {
            return ''
          }
        },

        getLocationImage: data => forms.getLocationImage(data),
        openTabIndex(index) {
            this.openedRecordIndex = index

            this.setStoreHiddenParameter ({
                target: 'nowQuestionPart',
                value: 'd'
            })
        },
        getSummaryAndDiagnosis(findingIndex, recordIndex, recordId) {
            const payload = {
                findingIndex,
                recordIndex,
                recordId
            }
            this.$store.dispatch('examinations/writeRecordDiagnosis', payload)
            // fetchArticle
            this.fetchOrderArticle({ examinationID: this.getExaminationData.examination.id })
            
        },
        showConfirmPopup(findingIndex, screenshotId, findingChangeId) {
            // console.log('in report finding details', findingIndex, screenshotId, findingChangeId)
            if (findingIndex > 0 || String(findingIndex) == '0') {
                this.$data.confirmTitle = `刪除`
                this.$data.confirmMessage = `刪除 Finding ${findingIndex+1}, 原本的Finding編號，將會被取代，確定要刪除嗎？`
                this.$data.onConfirmHandler = () => {
                    this.deleteFinding(findingIndex)
                }
            } else if (screenshotId && findingChangeId == null) {
                this.$data.confirmTitle = `刪除`
                this.$data.confirmMessage = `確定要刪除此圖片?`
                this.$data.onConfirmHandler = () => {
                    this.deleteScreenshot(screenshotId)
                    this.cancelDialog()
                }
            } else if (screenshotId && findingChangeId >= 0) {
                this.$data.confirmTitle = `移動圖片`
                this.$data.confirmMessage = `確定將圖片移到其他位置?`
                this.$data.onConfirmHandler = () => {
                    this.moveImgFromAllToFinding({
                        id: screenshotId,
                        newValue: findingChangeId
                    })
                    this.cancelDialog()
                }
            } else {
                return false
            }

            this.showDialog = true
            this.$forceUpdate()
        },
        editArticle(findingIndex, recordIndex) {
            var pluralRegExp = new RegExp('<font>([0-9a-zA-Z\n\\\\ =?:%!#&@*~<>_()+\\-,/\\[\\]{}"\'.]+)</font>');

            // diagnosis
            let result_diagnosis = this.getFindings[findingIndex].records[recordIndex].diagnosis.replace(/<br>/gi, "\|br\|").replace(/<i id/gi, "\|i id\|").replace(/<\/i>/gi, "\|end i\|").replace(/;/gi, 'sseemmiiccoolloonn');
            var temp_i = 0;
            while (pluralRegExp.test(result_diagnosis)) {
                const [foundLiteral, questionNumberString] = pluralRegExp.exec(result_diagnosis);
                var temp = '<textarea id="text_' + findingIndex + '_' + recordIndex + '_' + temp_i + '">' + questionNumberString + '</textarea>';
                result_diagnosis = result_diagnosis.replace(foundLiteral, temp);
                temp_i++;
            }
            document.getElementById('editDiagnosis_' + findingIndex + '_' + recordIndex).innerHTML = result_diagnosis.replace(/\|br\|/gi, "<br>").replace(/\|i id\|/gi, "<i id").replace(/\|end i\|/gi, "</i>").replace(/sseemmiiccoolloonn/gi, ";");

            // summary
            let result_summary = this.getFindings[findingIndex].records[recordIndex].summary.replace(/<br>/gi, "\|br\|").replace(/<i id/gi, "\|i id\|").replace(/<\/i>/gi, "\|end i\|").replace(/;/gi, 'sseemmiiccoolloonn');
            while (pluralRegExp.test(result_summary)) {
                const [foundLiteral, questionNumberString] = pluralRegExp.exec(result_summary);
                var temp = '<textarea id="text_' + findingIndex + '_' + recordIndex + '_' + temp_i + '">' + questionNumberString + '</textarea>';
                result_summary = result_summary.replace(foundLiteral, temp);
                temp_i++;
            }
            document.getElementById('editSummary_' + findingIndex + '_' + recordIndex).innerHTML = result_summary.replace(/\|br\|/gi, "<br>").replace(/\|i id\|/gi, "<i id").replace(/\|end i\|/gi, "</i>").replace(/sseemmiiccoolloonn/gi, ";");

            this.$store.dispatch('examinations/updateEditArticleStatus', {
                recordIndex: recordIndex,
                findingIndex: findingIndex,
                value: true
            });
            this.$forceUpdate();

            let inputObj = document.querySelectorAll("textarea[id^='text_" + findingIndex + "_" + recordIndex + "_']");
            for (let i = 0; i < inputObj.length; i++) {
                inputObj[i].setAttribute('style', 'width: 0px; max-height: 21px; min-height: 21px;');
                inputObj[i].setAttribute('style', 'width: ' + (inputObj[i].value.length * 7) + 'px; max-height: 21px; min-height: 21px;');
                var width = document.querySelectorAll("textarea[aria-label='Suggestion']")[findingIndex].offsetWidth - 37;
                if ((inputObj[i].value.length * 7) > width) {
                    var maxHeight = ((parseInt((inputObj[i].value.length * 7) / width)) + 2) * 21;
                    var minHeight = maxHeight;
                    inputObj[i].setAttribute('style', 'width: ' + width + 'px; max-height: ' + maxHeight + 'px; min-height: ' + minHeight + 'px;');
                } else {
                    inputObj[i].setAttribute('style', 'width: ' + (inputObj[i].value.length * 7) + 'px; max-height: 21px; min-height: 21px;');
                }
                inputObj[i].addEventListener("input", function() {
                    this.style.width = "0px";
                    if ((this.value.length * 7) > document.getElementById('editDiagnosis_' + this.id.split('_')[1] + '_' + this.id.split('_')[2]).parentNode.offsetWidth) {
                        this.style.width = document.getElementById('editDiagnosis_' + this.id.split('_')[1] + '_' + this.id.split('_')[2]).parentNode.offsetWidth + "px";
                        this.style.maxHeight = ((parseInt((this.value.length * 7) / document.getElementById('editDiagnosis_' + this.id.split('_')[1] + '_' + this.id.split('_')[2]).parentNode.offsetWidth)) + 2) * 21 + "px";
                        this.style.minHeight = this.style.maxHeight;
                    } else {
                        this.style.width = (this.value.length * 7) + "px";
                        this.style.maxHeight = "21px";
                        this.style.minHeight = "21px";
                    }
                });
            }
        },
        saveArticle(findingIndex, recordIndex) {

            let inputObj = document.querySelectorAll("textarea[id^='text_" + findingIndex + "_" + recordIndex + "_']");
            for (let i = 0; i < inputObj.length; i++) {
                var temp_space = '';
                if (inputObj[i].value.substr(inputObj[i].value.length - 1, 1) != ' ') {
                    temp_space = ' ';
                }
                inputObj[i].innerHTML = inputObj[i].value + temp_space;
            }

            var pluralRegExp = new RegExp('<textarea id="text_' + findingIndex + '_' + recordIndex + '_([0-9]+)" style="width: ([0-9]+)，semicolonpx， max-height: ([0-9]+)，semicolonpx， min-height: ([0-9]+)，semicolonpx，">([0-9a-zA-Z\n\\\\ =?:%!#&@*~<>_()+\\-,/\\[\\]{}"\'.]+)</textarea>');

            // diagnosis
            let result_diagnosis = document.getElementById('editDiagnosis_' + findingIndex + '_' + recordIndex).innerHTML.replace(/&lt;/gi, 'lltt').replace(/&gt;/gi, 'ggtt').replace(/&amp;/gi, 'aammpp').replace(/px;/gi, '，semicolonpx，').replace(/;/gi, 'sseemmiiccoolloonn');
            while (pluralRegExp.test(result_diagnosis)) {
                const [foundLiteral, idIndex, styleWidth, styleMaxHeight, styleMinHeight, questionNumberString] = pluralRegExp.exec(result_diagnosis);
                var temp = '<font>' + questionNumberString.replace(/\n/gi, " ").replace(/\r/gi, " ").replace(/  /gi, " ").replace(/lltt/gi, "<").replace(/ggtt/gi, ">").replace(/aammpp/gi, "&").replace(/sseemmiiccoolloonn/gi, ';').replace(/\\\\/gi, "\\") + '</font>';
                result_diagnosis = result_diagnosis.replace(foundLiteral, temp);
            }
            this.getFindings[findingIndex].records[recordIndex].diagnosis = result_diagnosis.replace(/，semicolonpx，/gi, 'px;');
            this.saveQuestionInput({
                findingIndex: findingIndex,
                recordIndex: recordIndex,
                event: {
                    field: 'diagnosis',
                    newValue: result_diagnosis.replace(/，semicolonpx，/gi, 'px;')
                }
            })

            // summary
            let result_summary = document.getElementById('editSummary_' + findingIndex + '_' + recordIndex).innerHTML.replace(/&lt;/gi, 'lltt').replace(/&gt;/gi, 'ggtt').replace(/&amp;/gi, 'aammpp').replace(/px;/gi, '，semicolonpx，').replace(/;/gi, 'sseemmiiccoolloonn');
            while (pluralRegExp.test(result_summary)) {
                const [foundLiteral, idIndex, styleWidth, styleMaxHeight, styleMinHeight, questionNumberString] = pluralRegExp.exec(result_summary);
                var temp = '<font>' + questionNumberString.replace(/\n/gi, " ").replace(/\r/gi, " ").replace(/  /gi, " ").replace(/lltt/gi, "<").replace(/ggtt/gi, ">").replace(/aammpp/gi, "&").replace(/sseemmiiccoolloonn/gi, ';').replace(/\\\\/gi, "\\") + '</font>';
                result_summary = result_summary.replace(foundLiteral, temp);
            }
            this.getFindings[findingIndex].records[recordIndex].summary = result_summary.replace(/，semicolonpx，/gi, 'px;');
            this.saveQuestionInput({
                findingIndex: findingIndex,
                recordIndex: recordIndex,
                event: {
                    field: 'summary',
                    newValue: result_summary.replace(/，semicolonpx，/gi, 'px;')
                }
            })

            this.$store.dispatch('examinations/updateEditArticleStatus', {
                recordIndex: recordIndex,
                findingIndex: findingIndex,
                value: false
            });
            this.$forceUpdate();
        }
    }
}
</script>

<style lang="scss" scoped>
  .records-form-container {
    border: 1px solid rgba(0,0,0,0.12);
    border-radius: 2px;
  }

  .forms-container {
    position: relative;
  }

  #forms-loading-container {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(225, 225, 225, 0.95);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .findings-tab-title {
    position: relative;
  }
  .finding-bottom{
    margin-top: 20px;
    text-align: center;
  }
  .findingTabActive{
    display: inline-table;
    justify-content: center;

    h1{
      height: 20px;
      width: 20px;
      color:white;
      background: #82b1ff; 
      font-size: 12px;
      -moz-border-radius: 70px; 
      -webkit-border-radius: 70px; 
      border-radius: 70px;
      margin: 3px auto;
      padding: 3px;
    }

    h4{
      margin: 0 0 3px 0;
      text-overflow: ellipsis;
    }
  }
  .findingTabDeactivate{
    display: inline-table;
    justify-content: center;
    width:100px;
    
    h1{
      height: 20px;
      width: 20px;
      color:white;
      background: #787878; 
      font-size: 12px;
      -moz-border-radius: 70px; 
      -webkit-border-radius: 70px; 
      border-radius: 70px;
      margin: 3px auto;
      padding: 3px;
    }

    h4{
      display: -webkit-box;
      margin: 0 0 3px 0;
      height: 12px ;
      overflow: hidden;
      -webkit-line-clamp: 1;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
    }
  }
</style>
<style scoped>
  /*
  .article {
    margin-top: 20px;
    text-align: left;
  }
  */
  .article {
    text-align: left;
  }
  .article>>>font {
    vertical-align: middle;
    word-break: normal;
  }
  .article>>>i {
    border-radius: 10px;
    /*background-color: #FFFF6F;*/
    font-style: normal;
    font-weight: bold;
    display: inline-block;
    vertical-align: middle;
    color: #2894FF;
  }
  .article>>>textarea {
    min-height: 21px;
    max-height: 21px;
    line-height: -20px;
    resize: none;
    outline: none;
    border: 0px;
    border-radius: 10px;
    background-color: rgb(220,220,220);
    display: inline-block;
    vertical-align: middle;
  }
</style>